/**
 * The centred card used by the public organisation join pages
 * (/join/org/:token and /o/:code), in the prototype's invite-flow design.
 */

import type { ReactNode } from 'react'
import { T } from '@/components/shell/orgTheme'

/** Top-aligned (21 Oct 2026), so the card's states — joining, declined, expired — don't move the logo. */
export function Shell({ children }: { children: ReactNode }) {
  return (
    <div style={{ minHeight: '100vh', background: T.page, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: 'clamp(32px, 10vh, 96px) 16px 10vh', gap: 28 }}>
      <img src="/learnbee-logo.png" alt="Learnbee" style={{ height: 26, width: 'auto' }} />
      <div style={{ width: 420, maxWidth: '100%', background: '#fff', border: `1px solid ${T.border}`, borderRadius: 18, padding: '32px 28px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, textAlign: 'center' }}>
        {children}
      </div>
    </div>
  )
}

export function Tile({ initials, bg = T.purple, fg = '#fff' }: { initials: string; bg?: string; fg?: string }) {
  return <div style={{ width: 56, height: 56, borderRadius: 14, background: bg, color: fg, display: 'grid', placeItems: 'center', fontWeight: 600, fontSize: 18 }}>{initials}</div>
}
